export const columnsOne = [{
    title: 'Job Title',
    dataIndex: 'form_values.b62d',
    key: 'title',
    width: 100,
  },{
    title: 'Start Date',
    dataIndex: 'form_values.c769',
    key: 'start',
    width: 100,
    className: 'hideThis'
  },{
    title: 'Location',
    dataIndex: 'form_values["94d5"]',
    key: 'location',
    width: 100,
    className: 'hideThis'
}];

export const columnsTwo = [{
    title: 'Driller',
    dataIndex: 'form_values["9ae5"].choice_values["0"]',
    key: 'driller',
    width: 100,
  }, {
    title: 'Rig',
    dataIndex: 'form_values["0a37"].choice_values["0"]',
    key: 'Rig',
    width: 100,
    className: 'hideThis'
  }, {
    title: 'Offsider',
    dataIndex: 'form_values.fb65.choice_values["0"]',
    key: 'Offsider',
    width: 100,
}];

export const dailyLog = [{
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    width: 60,
    render: date => {
      var str = date.split("-");
      var fYear = str[0],
          fMonth = str[1],
          fDay = str[2];
          
      return fDay + "-" + fMonth + "-" + fYear;
    }
  }, {
    title: 'Activity',
    dataIndex: 'log.form_values["0ad7"].choice_values["0"]',
    key: 'activity',
    width: 60,
  }, {
    title: 'Start',
    dataIndex: 'log.form_values["e418"]',
    key: 'start',
    width: 50,
  }, {
    title: 'Finish',
    dataIndex: 'log.form_values[8881]',
    key: 'finish',
    width: 50,
  }, {
  title: 'Description',
  dataIndex: 'log.form_values["99a3"]',
  key: 'description',
  width: 185,
  className: 'hideThis'
}, {
title: 'From',
dataIndex: 'log.form_values["9f30"]',
key: 'from',
width: 40,
className: 'hideThis'
}, {
title: 'To',
dataIndex: 'log.form_values["a988"]',
key: 'to',
width: 40,
className: 'hideThis'
}];

export const materials = [{
    title: 'Materials',
    dataIndex: 'mat',
    key: 'date',
    width: 60,
  }];

export const strata = [{
    title: 'From',
    dataIndex: 'from',
    key: 'from',
    width: 60,
  }, {
    title: 'To',
    dataIndex: 'to',
    key: 'to',
    width: 60,
  }, {
    title: 'Strata',
    dataIndex: 'strata',
    key: 'strata',
    width: 50,
  }];



// WEBPACK FOOTER //
// ./src/components/Bores/columns.js
